import * as Highcharts from 'highcharts';
import {useContext, useEffect, useRef, useState} from 'react';
import HighchartsReact from 'highcharts-react-official';
import {Card, CardContent} from '@mui/material';
import {COLORS} from '../../../../utils/constants';
import {getDefaultPieFormatting} from '../../charts/pie';
import {getValueByType} from '../../helpers/mapping';
import {ContainerContext} from '../../../../contexts/Container';

interface IActiveEntrepeneursProps {
    activeEntrepeneurs: {
        active: number;
        not_active: number;
    };
}

const ActiveEntrepeneurs = ({activeEntrepeneurs}: IActiveEntrepeneursProps) => {
    const {type} = useContext(ContainerContext);

    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
    const [options, setOptions] = useState<Highcharts.Options>();

    const title = getValueByType(type || '', 'active_entrepeneurs')

    const calculateSubmissions = () => {
        const data = [
            {
                name: 'Successfully concluded',
                y: activeEntrepeneurs.active,
                color: COLORS.blue,
            },
            {
                name: 'Dropouts',
                y: activeEntrepeneurs.not_active,
                color: COLORS.yellow,
            },
        ];

        const dashboardOptions: any = getDefaultPieFormatting(
            title,
            data
        );

        setOptions(dashboardOptions);
    };

    useEffect(() => {
        calculateSubmissions();
    }, []);

    return (
        <Card className='chart-container'>
            <CardContent>
                {options && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                        ref={chartComponentRef}
                    />
                )}
            </CardContent>
        </Card>
    );
};

export default ActiveEntrepeneurs;
